import {
  Fuel,
  HireUnitType,
  Transmission,
  VehicleApproximateAge,
  VehicleType,
} from "@/gql/graphql";

export const vehicleMessages = {
  type: {
    [VehicleType.BoxTruck]: "Box truck",
    [VehicleType.CamperVan]: "Campervan",
    [VehicleType.Car]: "Car",
    [VehicleType.FourWheelDrive]: "4WD",
    [VehicleType.FourWheelDriveCamper]: "4WD camper",
    [VehicleType.LuxuryCar]: "Luxury car",
    [VehicleType.MiniVan]: "Minivan / People Mover",
    [VehicleType.MotorHome]: "Motorhome",
    [VehicleType.Suv]: "SUV",
    [VehicleType.Ute]: "Ute",
    [VehicleType.Van]: "Van",
    [VehicleType.Caravan]: "Caravan",
  } satisfies {
    [key in VehicleType]: string;
  },
  transmission: {
    [Transmission.Automatic]: "Automatic",
    [Transmission.Manual]: "Manual",
    [Transmission.Unspecified]: "Unspecified",
  } satisfies {
    [key in Transmission]: string;
  },
  fuel: {
    [Fuel.Diesel]: "Diesel",
    [Fuel.Electric]: "Electric",
    [Fuel.Gasoline]: "Gasoline",
    [Fuel.Hybrid]: "Hybrid",
  } satisfies {
    [key in Fuel]: string;
  },
  approximate_age: {
    [VehicleApproximateAge.LessThanThreeYears]: "<3 years",
    [VehicleApproximateAge.LessThanFiveYears]: "<5 years",
    [VehicleApproximateAge.LessThanTenYears]: "<10 years",
    [VehicleApproximateAge.LessThanTwentyYears]: "<20 years",
    [VehicleApproximateAge.MoreThanTwentyYears]: ">20 years",
    [VehicleApproximateAge.New]: "New",
  } satisfies {
    [key in VehicleApproximateAge]: string;
  },
  hire_unit_type: {
    [HireUnitType.Day]: "Day",
    [HireUnitType.Night]: "Night",
    [HireUnitType.TwentyFourHours]: "24 hours",
  } satisfies {
    [key in HireUnitType]: string;
  },
  form: {
    supplier: "Supplier",
    name: "Name",
    name_tooltip: "The name the customer will see",
    code: "Code",
    code_tooltip: "The code the supplier has on their import lists",
    description: "Description",
    vehicle_type: "Vehicle type",
    fuel: "Fuel",
    transmission: "Transmission",
    vehicle_age: "Vehicle age",
    seatbelts: "Seatbelts",
    child_seat_anchors: "Child seat anchors",
    brand: "Brand",
    model: "Model",
    pet_friendly: "Pet friendly",
    pet_cleaning_fee: "Pet cleaning fee",
    sleeps: "Sleeps",
    self_contained: "Self contained",
    kitchen: "Kitchen",
    shower_and_toilet: "Shower & toilet",
    heating: "Heating",
    relocation_rate: "Relocation rate",
    charged_per: "Charged per",
    extra_hire_unit_rate: "Extra {unit} rate",
    supplier_net: "Supplier net",
    imoova_net: "Imoova net",
  },
  table: {
    image: "Image",
    name: "Name",
    code: "Code",
    unit: "Unit",
    extra_day_rate: "Extra day rate",
    type: "Type",
    transmission: "Transmission",
  },
};
